import { ChainTransactionStatus } from '@katanaperps/katana-perps-sdk';
import React from 'react';
import styled from 'styled-components';

import { readableFillStatus } from 'api/apiUtils';
import { ApiFill } from 'api/types';
import SimpleRoundedButton from 'components/basic/Button/SimpleRoundedButton';
import { LabelLink } from 'components/basic/Link/LabelLink';
import StopEventPropagationDiv from 'components/basic/panels/StopEventPropagationDiv';
import { getBlockExplorerTransactionUrl } from 'config/configUtils';
import { Chains } from 'reduxState/exchange/exchangeActiveChainUtils';

const Text = styled.span`
  text-transform: capitalize;
`;

export default function MyTradeClickableStatus({
  fill,
  activeChain,
}: {
  fill: Pick<ApiFill, 'txStatus' | 'txId'>;
  activeChain: Chains;
}) {
  return fill.txId ? (
    <StopEventPropagationDiv>
      <LabelLink
        type={
          fill.txStatus === ChainTransactionStatus.mined
            ? 'success'
            : fill.txStatus === ChainTransactionStatus.failed
            ? 'error'
            : 'info'
        }
        href={getBlockExplorerTransactionUrl(fill.txId, activeChain)}
      >
        <Text>{readableFillStatus(fill.txStatus)}</Text>
      </LabelLink>
    </StopEventPropagationDiv>
  ) : (
    <SimpleRoundedButton disabled>
      <Text>{readableFillStatus(fill.txStatus)}</Text>
    </SimpleRoundedButton>
  );
}
